import { render, staticRenderFns } from "./replace-do.vue?vue&type=template&id=efdcad52&"
import script from "./replace-do.vue?vue&type=script&lang=js&"
export * from "./replace-do.vue?vue&type=script&lang=js&"
import style0 from "./replace-do.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports